import { useTranslation } from "react-i18next"
import { HourReportWorkflow } from "../../../api"

export type HourReportingAdminsTranslations = typeof defaultTranslations & { infoDescription: string }

const defaultTranslations = {
  infoTitle: "Hour Reporting Admins",
  infoDescriptionReportingOnly: "Admins can make changes to hours reported by any member at any time.",
  infoDescriptionApproval: "Admins can approve and make changes to hours reported by any member at any time.",
  infoDescriptionCheckAndApproval:
    "Admins can check, approve and make changes to hours reported by any member at any time.",
  currentAdminsTitle: "Current Admins",
  addAdminLabel: "Add new admin",
  addButtonLabel: "Add",
  searchMembersPlaceholder: "Search members...",
  noOptionsText: "No members available",
  noAdminsText: "There are no hour reporting admins.",
  errorLoadingAdminsText: "Error loading hour reporting admins.",
  errorLoadingOptionsText: "Error loading members available for assignment.",
  updateAdminsErrorText: "Error updating hour reporting admins.",
  removeAdminLabel: "Remove {memberName} as an hour reporting admin",
}

export const useAdminInfoDescription = (workflow: HourReportWorkflow): string => {
  const { t } = useTranslation("org")

  return workflow === HourReportWorkflow.ReportingOnly
    ? t("orgMembershipsPage.hourReportingAdmins.infoDescriptionReportingOnly", {
        defaultValue: defaultTranslations.infoDescriptionReportingOnly,
      })
    : workflow === HourReportWorkflow.Approval
    ? t("orgMembershipsPage.hourReportingAdmins.infoDescriptionApproval", {
        defaultValue: defaultTranslations.infoDescriptionApproval,
      })
    : t("orgMembershipsPage.hourReportingAdmins.infoDescriptionCheckAndApproval", {
        defaultValue: defaultTranslations.infoDescriptionCheckAndApproval,
      })
}

export const useTranslations = (workflow: HourReportWorkflow): HourReportingAdminsTranslations => {
  const { t } = useTranslation("org")
  const infoDescription = useAdminInfoDescription(workflow)

  return {
    infoTitle: t("orgMembershipsPage.hourReportingAdmins.infoTitle", { defaultValue: defaultTranslations.infoTitle }),
    infoDescriptionReportingOnly: t("orgMembershipsPage.hourReportingAdmins.infoDescriptionReportingOnly", {
      defaultValue: defaultTranslations.infoDescriptionReportingOnly,
    }),
    infoDescriptionApproval: t("orgMembershipsPage.hourReportingAdmins.infoDescriptionApproval", {
      defaultValue: defaultTranslations.infoDescriptionApproval,
    }),
    infoDescriptionCheckAndApproval: t("orgMembershipsPage.hourReportingAdmins.infoDescriptionCheckAndApproval", {
      defaultValue: defaultTranslations.infoDescriptionCheckAndApproval,
    }),
    infoDescription,
    currentAdminsTitle: t("orgMembershipsPage.hourReportingAdmins.currentAdminsTitle", {
      defaultValue: defaultTranslations.currentAdminsTitle,
    }),
    addAdminLabel: t("orgMembershipsPage.hourReportingAdmins.addAdminLabel", {
      defaultValue: defaultTranslations.addAdminLabel,
    }),
    addButtonLabel: t("orgMembershipsPage.hourReportingAdmins.addButtonLabel", {
      defaultValue: defaultTranslations.addButtonLabel,
    }),
    searchMembersPlaceholder: t("orgMembershipsPage.hourReportingAdmins.searchMembersPlaceholder", {
      defaultValue: defaultTranslations.searchMembersPlaceholder,
    }),
    noOptionsText: t("orgMembershipsPage.hourReportingAdmins.noOptionsText", {
      defaultValue: defaultTranslations.noOptionsText,
    }),
    noAdminsText: t("orgMembershipsPage.hourReportingAdmins.noAdminsText", {
      defaultValue: defaultTranslations.noAdminsText,
    }),
    errorLoadingAdminsText: t("orgMembershipsPage.hourReportingAdmins.errorLoadingAdminsText", {
      defaultValue: defaultTranslations.errorLoadingAdminsText,
    }),
    errorLoadingOptionsText: t("orgMembershipsPage.hourReportingAdmins.errorLoadingOptionsText", {
      defaultValue: defaultTranslations.errorLoadingOptionsText,
    }),
    updateAdminsErrorText: t("orgMembershipsPage.hourReportingAdmins.updateAdminsErrorText", {
      defaultValue: defaultTranslations.updateAdminsErrorText,
    }),
    removeAdminLabel: t("orgMembershipsPage.hourReportingAdmins.removeAdminLabel", {
      defaultValue: defaultTranslations.removeAdminLabel,
    }),
  }
}
